import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { SendSmsMessageComponent } from './send-sms-message/send-sms-message.component';
import { SmsMessageDetailsComponent } from './sms-message-details/sms-message-details.component';
import { SmsMessagesListComponent } from './sms-messages-list/sms-messages-list.component';
import { SmsMessagesRoutingModule } from './sms-messages-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SmsMessagesRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    SmsMessagesListComponent,
    SendSmsMessageComponent,
    SmsMessageDetailsComponent
  ],
  entryComponents: [
    SendSmsMessageComponent,
    SmsMessageDetailsComponent
  ]
})
export class SmsMessagesModule {
}
